import React from 'react';
import CategoryPage from '../components/category/CategoryPage';

function SamajPage({ onOpen }) {
  return <CategoryPage onOpen={onOpen} title="समाज" catSlug="entertainment" color="#8B3FA6" />;
}

export default SamajPage;